import {FieldController} from "./elements.field.controller";




var moment = require('moment');


const zeroPad = (num, places) => String(num).padStart(places, '0')


var tootipsMaster = false ;
//var errorsMaster = false ; 
var bx = window.BX; 



bx.ajax.runComponentAction('cript:desktop', 'master-tootips', {
    mode:'class',
    data:{}
}).then(function(response){
   
    
    if(response.status!=="success"){
       
        console.error('unable load tooltip ');
       
        return;
    }
    tootipsMaster =response.data;


},function( ){
    
});

bx.ajax.runComponentAction('cript:desktop', 'master-errors-settings', {
    mode:'class',
    data:{}
}).then(function(response){
   
    
    if(response.status!=="success"){
       
        console.error('unable load errorsMaster ');
       
        return;
    }
  //  errorsMaster =response.data;


},function( ){
    
});


class InputController   extends FieldController {
    static get $inject(){ return   ['$log', '$scope', '$element'] }
    constructor($log, $scope, $element){
       

        super($log, $scope, $element);
        this.controlClass = this.constructor.name.replace('Controller','')
        
        this.changed ;
        this.isInited = false;
        this.__model ={};
        


    }
    $onInit(){
        super.$onInit();
        
    }
    onSaveForm  (event, data){
        if(!this.notAllowEmpty){
           return;
        }
        if(!this.__model){
            data.haveError(this);
        }
    }

    get isInit(){
        return this.isInited
    }
    get model(){
        
        return this.__model

    }
    set model(value){
        this.__model = value;

        if(!this.isInit){
            this.changed = false;
            this.isInited =  true
        }else{
            this.changed = true;
            
        }

        if(this.changed){
            this.haveError = false;
        }
    }

    get IsChanged(){
        return this.changed ; 
    }

    

}

class inputFioController  extends FieldController  {
    
    static get $inject(){ return   ["$element", '$scope', '$log']}


    constructor($element, $scope, $log) {
        super($log, $scope, $element);
        this.$element = $element;
        this.scope = $scope;
        //this.secondName = false;
        this._haveSecondName = true;
        this._originalSecondName = '';
        
    }
    
  
    onSaveForm  (event, data){

        if(!this.notAllowEmpty){
            return
        }

        let error = false;
            
        if(this._haveSecondName && ! this.model.MiddleName){
            error = true;
        }
        
        for (const key in this._fields) {

            if(this.model[key]){
                continue;
            }

           
          
            if(key=='MiddleName' && !this._haveSecondName){
                continue;
            }
           
            error = true;
          
            this.$scope.$broadcast('errorEvent',{
                field: this._fields[key].fieldName,
                message:'Необходимо заполнить поле',
            })

        }
      

        if(error){
            data.haveError(this);
        }

    }

    get haveSecondName(){
        return this._haveSecondName===false?'N':'Y';
    }

    set haveSecondName(value){
        
        if(value=='Y'){
            this._haveSecondName=true;
            this.model.MiddleName = this._originalSecondName;
            this.model.HaveMiddleName = 1;
        }else{
            this.model.MiddleName =''; 
            this._haveSecondName=false;
            this.model.HaveMiddleName = 0;
        }
    }

    $onInit() {
        super.$onInit();
        
        
        
        this.$scope.$on('before::save', this.onSaveForm.bind(this));
        

        if(this.toolTipInfo && this.tooltip){
            this.toolTipInfo.tooltipster('', this.tooltip );
        }
       if(!this.model){
        this.model = {};
       }
        //this.haveSecondName = 'N';
        if(this.model.MiddleName || this.model.HaveMiddleName){
            this._originalSecondName = this.model.MiddleName;
            this.haveSecondName = 'Y';
            this.redraw()
         
        }
    }

    onInitFields(event, data){
        switch(data.name){
            case "model.LastName":
            case "model.Name":
            case "model.MiddleName":
            this._fields[data.name.replace('model.','')] = data.field;
            break;
        }

    }
}

class inputSNILSController  extends InputController  {
    static get $inject(){ return  ['$log', '$scope', '$element'];}
    constructor($log, $scope, $element){
        super($log, $scope, $element);
    }

    $onInit(){
        super.$onInit();
        //this.$scope.$on('before::save', this.onSaveForm.bind(this));
       // this.notAllowEmpty = false;
       
    }

    onSaveForm  (event, data){
        if(!this.notAllowEmpty){
           return;
        }
        if(!this.__model){
            data.haveError(this);
        }
    }
    

    $postLink(){
        this.input =  $('input', this.$element);
        if(this.mask ){
            this.input.mask(this.mask, {
                placeholder: "_"
            });
        }
    }

}

class inputGenderController  extends FieldController  {
    static get $inject(){ return  ['$log', '$scope', '$element'];}

    constructor($log, $scope, $element){
        super($log, $scope, $element);
        this._model = null ;
    }

    $onInit(){
        super.$onInit();
        this.$scope.$on('before::save', this.onSaveForm.bind(this));
        this.errorMessage ='Необходимо выбрать пол, или ламинат'
    }
  
    onSaveForm  (event, data){
        
        if(!this.model){
          //e.warn('set error by gender '+this.fieldName, this.model);
            data.haveError(this);
        }

    }

    get model(){
        return this._model;
    }

    set model(value){
        this._model = value ;  
        this.haveError = false;
    
    }

}



class inputRegistrationController   extends FieldController {
    static get $inject(){ return  ['$log', '$scope', '$element'];}
    constructor($log, $scope, $element){
        super($log, $scope, $element);
    }
}









class inputSwitchController   extends FieldController {

    static get $inject(){ return   ["$element", '$log', '$scope']}

    constructor($element, $log, $scope) {
        super($log, $scope, $element)
        this.$element = $element;
        this.checkBox = false;
//        this.textNot  ='Да',
//        this.textYes  ='Нет',
    }

    get model() {
        switch(this.bxType){
            case 'string':
                return  this.checkBox?'Y':'N';
            case 'int':
                return this.checkBox?1:0;
            case 'bool':
            default:
                return this.checkBox?true:false;
        }
    }

    set model(value) {
  
        switch(this.bxType){
            case 'string':
                this.checkBox = value=='Y'?true:false;
                break;
            case 'int':
                this.checkBox = value==1?true:false;
                break;
            case 'bool':
            default:
                this.checkBox = value?true:false;
        }
    }

    ChangeState(){
       
      
        switch(this.bxType){
            case 'string':
                this.model = this.checkBox?'Y':'N';
                break;
            case 'int':
                this.model = this.checkBox?1:0;
                break;
            case 'bool':
            default:
                this.model = this.checkBox?true:false;
        }


    }

    $postLink (){
      
        super.$postLink();
    }

}



class inputTextController  extends FieldController  {
    static get $inject(){ return   ["$element", '$log', '$scope'];}
    constructor($element, $log, $scope) {
        super($log, $scope, $element)
        this.$element = $element;
     
        this.__mask = null;
        this.$scope.$on('field.change.state', this.onChangeState.bind(this));

        this.query = [] ;
        this.queryState = [] ;
        this.__isDisabled = false

    }

    onTypeEnd(){
        this.onChanged({text: $('input',this.$element).val(),  mText:this.model });
    }
   
    onKeyup(){
        
        this.haveError = false;
        this.errorMessage = false;

        if(this.timer){
            clearTimeout(this.timer);
        }else{
            this.onStartType();
        }
        setTimeout(this.onTypeEnd.bind(this), 300);
    }

    $onInit() {
        super.$onInit();
        this.onInit({domNode:this.$element})
        this.$scope.$on('before::save', this.onSaveForm.bind(this));
     
    }
  
    onSaveForm  (event, data){

        if(!this.notAllowEmpty){
            return
        }
   
        if(!this.model){
            data.haveError(this);
        }

    }

    
    get mask(){
        return this.__mask;
    }

    set mask(value){
       ///console.info('set mask '+this.fieldName+' '+value );

        this.__mask = value;

       
        if(value){
            if(!this.input){
                
                return ;
            }else{
                this.input.mask(value, {
                    placeholder: "_"
                });
            }

        }else if(this.input){
            this.input.trigger("unmask");
        }
      
    }

    $postLink(){
        this.input =  $('input', this.$element);
        if(this.queryState.length){
            this.queryState.forEach(element => {
                this.onChangeState(null, element)
            });
    
            this.queryState= [] ;
        }

        if(this.__mask ){
            this.input.mask(this.__mask, {
                placeholder: "_"
            });
        }
    }


    onChangeState(event, data){

        if(data.field!=this.fieldName){
            return;
        }
    
        if(!this.input){
            this.queryState.push(data);
            return ;
        }

        this.__isDisabled =   data.disabled

    }


}




class inputTextSwitchController extends inputTextController{
    static get $inject(){ return   ["$element", '$log', '$scope'];}
    constructor($element, $log, $scope) {
        super( $element, $log, $scope)
    }

    get switch(){
        return this.__switch;
    }

    set switch(value){
        this.__switch = value
    }

}

class inputOGRNController  extends FieldController  {
    static get $inject(){ return   ["$element", '$log', '$scope']}

    constructor($element, $log, $scope) {
        super($log, $scope, $element)
        this.$element = $element;
        this.haveError = false ; 
        this.error = {};
        this.mask = "9999999999999";
    }

   
    get ogrn(){
        return this.model;//this.format(this.model);
    }

    set ogrn(value){

        this.model = value.replace(/-/g, "")
        //this.validateOgrn( this.model) ; 
    }
    onChanged(){
        
      //  console.info('set egrul is '+ogrn);
       // this.validateOgrn(ogrn.replace(/-/g, "")) ; 
        
      
    }



    format(value) {
        if(!value){
            return '';
        }
        var i = 0,
            v = value.toString();
        return this.mask.replace(/9/g, () => v[i++]);
    }

    onTextInit(element){
        this.childElement = element;

        this.info("onTextInit  text->ogrn !", {
            self:this,
            input: $('input', element )
        })

        $('input', element ).mask(this.mask, {
            placeholder: "0"
        });
    }

    validateOgrn(ogrn) {
        var result = false;
        this.error = {};

        if (typeof ogrn === 'number') {
            ogrn = ogrn.toString();
        } else if (typeof ogrn !== 'string') {
            ogrn = '';
        }
        if (!ogrn.length) {
            this.error.code = 1;
            this.error.message = 'ОГРН пуст';
        } /*else if (/[^0-9]/.test(ogrn)) {
            this.error.code = 2;
            this.error.message = 'ОГРН может состоять только из цифр';
        } else if (ogrn.length !== 13) {
            this.error.code = 3;
            this.error.message = 'ОГРН может состоять только из 13 цифр';
        } else {
            var n13 = parseInt((parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1));
            if (n13 === parseInt(ogrn[12])) {
                result = true;
            } else {
                this.error.code = 4;
                this.error.message = 'Неправильное контрольное число';
            }
        }*/


        if(!result){
            console.error('bad ogrn -  '+this.error.message );
            this.errorMessage = this.error.message 
            
        }
        this.haveError = !result;
    }

    $postLink(){
        super.$postLink();
    }

    onSaveForm  (event, data){
        if(!this.notAllowEmpty){
           return;
        }
        if(!this.model || !this.ogrn){
            this.haveError = true;
            data.haveError(this);
            this.$scope.$broadcast('errorEvent',{
                field: this._fields.ogrn.fieldName,
                message:'Необходимо заполнить поле',
            })
        }

        
    }

    $onInit() {
        super.$onInit();
        this.$scope.$on('before::save', this.onSaveForm.bind(this));
    }

    onInitFields(event, data){

        this._fields[data.name.replace('model.','')] = data.field;


    }



}

class inputEGRIPController  extends inputOGRNController  {
    static get $inject(){ return   ["$element", '$log', '$scope']}

    constructor($element, $log, $scope) {
        super($element, $log, $scope)
        this.$element = $element;
        this.haveError = false ; 
        this.error = {};
        this.mask = "999999999999999";
       
    }
    validateOgrn(ogrn) {
        var result = false;
        this.error = {};

        if (typeof ogrn === 'number') {
            ogrn = ogrn.toString();
        } else if (typeof ogrn !== 'string') {
            ogrn = '';
        }
        if (!ogrn.length) {
            this.error.code = 1;
            this.error.message = 'ЕГРИП пуст';
        } /*else if (/[^0-9]/.test(ogrn)) {
            this.error.code = 2;
            this.error.message = 'ЕГРИП может состоять только из цифр';
        } else if (ogrn.length !== 15) {
            this.error.code = 3;
            this.error.message = 'ЕГРИП может состоять только из 15 цифр';
        } else {
            var n15 = parseInt((parseInt(ogrn.slice(0, -1)) % 13).toString().slice(-1));
            if (n15 === parseInt(ogrn[14])) {
                result = true;
            } else {
                this.error.code = 4;
                this.error.message = 'Неправильное контрольное число';
            }
        }*/


        if(!result){
            console.error('bad ogrn -  '+this.error.message );
            this.errorMessage = this.error.message 
            
        }
        this.haveError = !result;
    }

  


}



class inputBankController   extends FieldController {
    static get $inject(){ return  ['$log', '$scope', '$element'];}
    constructor($log, $scope, $element){
        super($log, $scope, $element);
    }

    
    $onInit() {
        super.$onInit();
        this.$scope.$on('before::save', this.onSaveForm.bind(this));
    }

    onSaveForm  (event, data){

        
        let error= false;
        if(!this.notAllowEmpty){
           return;
        }
       
        //     data.haveError(this);
        for (const key in this._fields ) {
            if (Object.hasOwnProperty.call(this._fields , key)) {
                const element = this._fields[key];
                if(element  instanceof inputTextController){
                    if(!element.model){
                        this.$scope.$broadcast('errorEvent',{
                            field: this._fields[key].fieldName,
                            message:'Необходимо заполнить поле',
                        })
                        error = true;
                    }
                }
            }
        }

        if(error){
            data.haveError(this);
        }
        
    }

    onInitFields(event, data){

            this._fields[data.name.replace('model.','')] = data.field;


    }


}


class inputYearMonthController extends  FieldController {
    static get $inject(){ return  ['$element','$log',  '$scope'];}
    

    constructor($element,$log, $scope ){
        super($log, $scope, $element);
        this.$element = $element;
        this.__model = '';
        this.modelSelect={
            year:'',
            month:''
        }

        var iter = 0;
        this.month = moment.months().map((el)=>{
            return {
                id: ''+zeroPad(++iter, 2),
                text: el, 
               
            }
        });
        this.year = [] ;
        let year = (moment().year())-1;

        for (let i = year; i <=  year+5; i++) {
            this.year.push({
                id: ''+i,
                text: ''+i,
               
            });
        }

        this._fields = {}

    }



    get model(){
        
        this.__model = this.modelSelect.month+'.'+this.modelSelect.year;
        return this.__model;
    }

    set model(value){
        this.__model = value;
        let year = '';
        let month = '';
        let data = [] ;

        if(this.__model){
            data = this.__model.split('.');
        }

        if(!(month=data.shift())){
            month='';
        }

        if(!(year=data.shift())){
            year='';
        }

        this.modelSelect.year = year;
        this.modelSelect.month = month

    }


    onSaveForm  (event, data){
        if(!this.notAllowEmpty){
           return;
        }


        if(!this.modelSelect.year ||  !this.modelSelect.month){
            data.haveError(this);
        }else{
            return ;
        }

        const baseName = this.fieldName.replace('model.','') ; 

        if(!this.modelSelect.year){
            this.$scope.$broadcast('errorEvent',{
                field: this._fields[baseName+'.year'].fieldName,
                message:'Необходимо заполнить год',
            })
        }

        if(!this.modelSelect.month){
            this.$scope.$broadcast('errorEvent',{
                field: this._fields[baseName+'.month'].fieldName,
                message:'Необходимо заполнить месяц',
            })
        }

    }
    
    onInitFields(event, data){
        const fieldName  =data.name.replace('model.','');
        this._fields[fieldName]= data.field
      
    }

    

}



class inputCheckBoxController  extends FieldController {
    
    static get $inject(){ return  ['$element','$log', 'BXReferenceService', 'referenceEntity', '$scope'];}
    

    constructor($element,$log, BXReferenceService, referenceEntity, $scope){
        super($log, $scope, $element);
        this.$element = $element;
        this.trueValue = 1
        this.falseValue = 0


    }


}

class inputCheckBoxPrivacyController  extends FieldController {
    
    static get $inject(){ return  ['$element','$log', 'BXReferenceService', 'referenceEntity', '$scope'];}
    

    constructor($element,$log, BXReferenceService, referenceEntity, $scope){
        super($log, $scope, $element);
        this.$element = $element;
        this.trueValue = 1
        this.falseValue = 0

    }
}


class modalMapController extends FieldController{

    static get centerMap() {return  [37.62,55.75];}
    static get zoomMap (){ return   17;}
    static get type() { return   'yandex#hybrid'}

    static get controls(){ return  [
        'smallMapDefaultSet','rulerControl'
    ]}

    static get $inject(){ return  ['$element','$log', 'BXReferenceService', 'referenceEntity', '$scope', 'ymapsLoader'];}
    

    constructor($element,$log, BXReferenceService, referenceEntity, $scope, ymapsLoader){
        super($log, $scope, $element);
        this.$element = $element;
        this.reference = BXReferenceService;
        this.refentity = referenceEntity;
        this.scope = $scope

        this.__visible = false;
        this.modal  = null;
        this.allowPaint = false;
        this.currentIndex = 0;

        this.isVruAdedd = false; 
        this.buttons ={};
        this.yamapLoader = ymapsLoader;
       
    }


    $postLink(){
        this.yamapLoader.ready(this.initModal.bind(this));
        /*bx.loadScript([
                "https://api-maps.yandex.ru/2.1/?lang=ru_RU",
               // '/local/mosoblenergo/js/paintOnMap.js'
            ],bx.delegate(this. initModal, this)
        );*/
        super.$postLink();

    }

    get visible(){
        return this.__visible
    }

    set visible(value){
        this.__visible = value;

        //let doWork = this.__visible?this.showModal:this.hideModal;
    
        if(!this.modal){
            return
        }
        if(value){
            this.showModal();
        }else{
            this.hideModal(); 
        }
    }
    initModal(){
 
        if(this.modal){
            return ;
        }
        
        this.modal  = $('#map-modal', this.$element);
        
        if(this.modal){
            this.yamapLoader.ready(bx.delegate(this.initYamap ,this));
        }
        
    }
    createPrimitive(){
        this.myPolygon = new this.yamap.Polygon([], {}, {
            // Курсор в режиме добавления новых вершин.
            editorDrawingCursor: "crosshair",
            // Максимально допустимое количество вершин.
            editorMaxPoints: 11,
            // Цвет заливки.
            //fillColor: '#00FF00',
            // Цвет обводки.
            strokeColor: '#0000FF',
            // Ширина обводки.
            strokeWidth: 5
        });


        this.myPolygon.editor.options.set({
            menuManager: bx.delegate(this.menuManager, this)
        });
        
        this.myPolyline = new this.yamap.Polyline([], {}, {
            // Задаем опции геообъекта.
            // Цвет с прозрачностью.
            editorDrawingCursor: "crosshair",
            draggable: true,
            strokeColor: "#eff718",
            // Ширину линии.
            strokeWidth: 4,
            // Максимально допустимое количество вершин в ломаной.
            editorMaxPoints: 11,
            // Добавляем в контекстное меню новый пункт, позволяющий удалить ломаную.
            editorMenuManager: function (items) {
                    items.push({
                        title: "Удалить линию",
                        onClick: bx.delegate(this.removePolyline, this)
                    });
                    return items;
                }
            }
        );
        this.myPoints = new this.yamap.Polyline([], {}, {
            // Задаем опции геообъекта.
            // Цвет с прозрачностью.
            editorDrawingCursor: "crosshair",
            draggable: true,
            strokeColor: "#eff718",
            // Ширину линии.
            strokeWidth: 4,
            // Максимально допустимое количество вершин в ломаной.
            editorMaxPoints: 1,
        });
    }

    createButton(name, option, callback){
        let config = {data:{},options:{
            maxWidth: [100],
            floatIndex: Object.keys(this.buttons).length,
            selectOnClick:false,
            layout: this.yamap.templateLayoutFactory.createClass(
               "<div class='btn btn--orrange btn-ya-"+name+" ' title='{{ data.title }}'>" +
               "{{ data.content }}" +
               "</div>"
            ),

        }};

        config.data.content = option.label;
        if(option.hasOwnProperty('title')){
            config.data.title = option.title;
        }
        if (option.hasOwnProperty('visible')) {
            config.options.visible = option.visible;
        }

        this.buttons[name] = new this.yamap.control.Button(config); 
        this.map.controls.add(this.buttons[name], {float: 'left'});
        this.buttons[name].events.add('click',bx.delegate(callback, this));
    
    }

    addUI(){
        //1 save
        this.createButton('save',{
            label:'Сохранить',
            visible: false,
        }, this.onSave);

        //1 clear
        this.createButton('reset',{
            label:'Сбросить',
            visible: false,
        }, this.onReset);
        
        //2
        this.createButton('vru',{
            label:'ВРУ',
            title: 'Укажите место размещения вводного распределительного устройства (ВРУ). Перетащите указатель на место ВРУ',
            visible: false,
        }, this.onAddVru);

        //3 drop down

        this.createListBox();

        //4 end draw
        this.createButton('endDraw',{
            label:'Завершить рисование',
            visible: false,
        }, this.onEndDraw);

        
    }

    createListBox(){
         // Создадим собственный макет выпадающего списка.
         var ListBoxLayout = this.yamap.templateLayoutFactory.createClass(
            "<button id='my-listbox-header' class='btn btn--orrange dropdown-toggle' data-toggle='dropdown'>" +
                "{{data.title}} <span class='caret'></span>" +
            "</button>" +
            // Этот элемент будет служить контейнером для элементов списка.
            // В зависимости от того, свернут или развернут список, этот контейнер будет
            // скрываться или показываться вместе с дочерними элементами.
            "<ul id='my-listbox'" +
                " class='dropdown-menu' role='menu' aria-labelledby='dropdownMenu'" +
                " style='display: {% if state.expanded %}block{% else %}none{% endif %};'></ul>", {

            build: function() {
                // Вызываем метод build родительского класса перед выполнением
                // дополнительных действий.
                ListBoxLayout.superclass.build.call(this);

                this.childContainerElement = $('#my-listbox').get(0);
                // Генерируем специальное событие, оповещающее элемент управления
                // о смене контейнера дочерних элементов.
                this.events.fire('childcontainerchange', {
                    newChildContainerElement: this.childContainerElement,
                    oldChildContainerElement: null
                });
            },

            // Переопределяем интерфейсный метод, возвращающий ссылку на
            // контейнер дочерних элементов.
            getChildContainerElement: function () {
                return this.childContainerElement;
            },

            clear: function () {
                // Заставим элемент управления перед очисткой макета
                // откреплять дочерние элементы от родительского.
                // Это защитит нас от неожиданных ошибок,
                // связанных с уничтожением dom-элементов в ранних версиях ie.
                this.events.fire('childcontainerchange', { 
                    newChildContainerElement: null,
                    oldChildContainerElement: this.childContainerElement
                });
                this.childContainerElement = null;
                // Вызываем метод clear родительского класса после выполнения
                // дополнительных действий.
                ListBoxLayout.superclass.clear.call(this);
            }
    })

        // Также создадим макет для отдельного элемента списка.
    let ListBoxItemLayout = this.yamap.templateLayoutFactory.createClass(
            "<li><a>{{data.content}}</a></li>"
    )

    // Создадим 2 пункта выпадающего списка
    let listBoxItems = [
        new this.yamap.control.ListBoxItem({
            data: {
                content: 'Точка',
                eventid: 1,
                center: [37.573856, 55.751574],
                zoom: 9
            }
        }),
        new this.yamap.control.ListBoxItem({
            data: {
                content: 'Линия',
                eventid: 2,
                center: [73.365535, 54.990215],
                zoom: 9
            } 
        }),
        new this.yamap.control.ListBoxItem({
            data: {
                content: 'Полигон',
                eventid: 3,
                center: [73.365535, 54.990215],
                zoom: 9
            }
        })
    ];

        // Теперь создадим список
        this.buttons.listBox = new this.yamap.control.ListBox({
                    items: listBoxItems,
                    data: {
                        title: 'Рисовать'
                    },
                    options: {
                        floatIndex: 5,
                        // С помощью опций можно задать как макет непосредственно для списка,
                        layout:  ListBoxLayout,
                        // так и макет для дочерних элементов списка. Для задания опций дочерних
                        // элементов через родительский элемент необходимо добавлять префикс
                        // 'item' к названиям опций.
                        itemLayout: ListBoxItemLayout
                    }
        });

        this.buttons.listBox.events.add('click', bx.delegate(this.onListBoxClick, this));
        this.map.controls.add(this.buttons.listBox, {float: 'left'});
    }

    initYamap(yamap){
        this.yamap = yamap;

        if(!$("#js-map-paint").length){
            return;
        }
        this.map = new yamap.Map("js-map-paint", {
            center: modalMapController.centerMap,
            zoom: modalMapController.zoomMap,
            type: modalMapController.type,
            controls: modalMapController.controls
            
        });
        this.onInited();

        this.createPrimitive();
        this.addUI();

        this.myPolyline.editor.options.set({
            menuManager: bx.delegate(this.menuManager, this)
        });
        

        // В режиме добавления новых вершин меняем цвет обводки многоугольника.
        this.handleMonitorStates(this.myPolygon, "drawing", this.onDrawing);
        this.handleMonitorStates(this.myPoints, "drawing", this.onDrawing);
        this.handleMonitorStates(this.myPolyline, "drawing", this.onDrawing);
        
        this.myPolyline.editor.events.add("vertexadd", bx.delegate(this.onVertexAdd, this));
        this.myPolygon.editor.events.add("vertexadd", bx.delegate(this.onVertexAdd, this));

    }

    handleMonitorStates(obj, event, handler){
        var stateMonitor = new this.yamap.Monitor(obj.editor.state);
        stateMonitor.add(event, bx.delegate(handler, this));
    }

    onListBoxClick (e) {
        // Получаем ссылку на объект, по которому кликнули.
        // События элементов списка пропагируются
        // и их можно слушать на родительском элементе.
        let item = e.get('target');
        // Клик на заголовке выпадающего списка обрабатывать не надо.
        if (item != this.buttons.listBox) {
            this.buttons.listBox.data.set('title', item.data.get('content'));
            this.myobj(item.data.get('eventid'));
            //myMap.setCenter(
            //    item.data.get('center'),
            //    item.data.get('zoom')
            //);
            this.buttons.listBox.collapse();
        }
    }

    removePolyline(){
        
        this.map.geoObjects.remove(this.myPolyline);
        
    }
    menuManager(editorItems/*, model*/){
        for(var i=0; i<editorItems.length; i++){
        if(editorItems[i].id==='removeVertex') editorItems[i].title='Удалить точку';
        if(editorItems[i].id==='startDrawing') editorItems[i].title='Продолжить рисование';
        if(editorItems[i].id==='stopDrawing') editorItems[i].title='Завершить рисование';
        if(editorItems[i].id==='addInterior') editorItems.splice(i, 1);
        }
        return editorItems;
    }
    onMouseDown(e){

        if(!this.allowPaint){
            return ;
        }

        if (this.currentIndex == modalMapController.styles.length - 1) {
            this.currentIndex = 0;
        } else {
            this.currentIndex += 1;
        }

        this.paintProcess = this.yamap.ext.paintOnMap(this.map, e, {
            style: modalMapController.styles[this.currentIndex],
        });
 
    }

    onDrawing(newValue){
        this.info('drawing', newValue);
      
        if(this.myPolyline.editor.state.get('editing')){
            this.myPolygon.options.set(
                "strokeColor", 
                newValue ? '#FF0000' : '#0000FF'
            );

            this.ssilka = this.yamap.geometry.Polygon.toEncodedCoordinates(
                this.myPolygon.geometry
            );

        }

        if(!newValue){
            this.buttonVisible('vru', true);
            this.buttonVisible('reset', true);
        }
    }
    onVertexAdd(event){
        this.info('onVertex Add', event);
        if(
            this.myPolyline.editor.state.get('editing')
            && event.get('vertexIndex')>0
        ){
            this.buttonVisible('endDraw', true);
        }
   
        if(
            this.myPolygon.editor.state.get('editing')
            && event.get('vertexIndex')>1
        ){
            this.buttonVisible('endDraw', true);
        }
    }
    onEndDraw (/*event*/){
        this.info('onendDraw');
        this.myPolygon.editor.stopDrawing();
        this.myPolyline.editor.stopDrawing();
    }


    createDataYad(){
        var points='',
            coord=this.map.getCenter(),
            center='&ll='+coord,
            VRUcoord =this.placemarkVRY.geometry.getCoordinates(),
            VRU = '~'+VRUcoord+',pm2bl',
            ssilka = '',
            urencod ='',
            dataPoints = []
            
        ;



        if(this.myPolygon.getMap()){
            let point='',
                linarr=this.myPolygon.geometry.getCoordinates()[0].length,
                ogr=linarr-1
            ;
            for (let i=0; i<linarr; i++){
                if(i<ogr){
                    let zpt = i>0 ? point+'~' : '';
                    point=zpt+this.myPolygon.geometry.getCoordinates()[0][i]+',pmwtm'+(i+1);
                    dataPoints.push(this.myPolygon.geometry.getCoordinates()[0][i]);
                }
            }

            points='&pt='+point;
            
            urencod = this.yamap.geometry.Polygon.toEncodedCoordinates(this.myPolygon.geometry);
            ssilka = 'http://static-maps.yandex.ru/1.x/?l=sat,skl&z=17&pl=c:faff00,'+urencod;

        }else if(this.myPolyline.getMap()){
            let point='',
                linarr=this.myPolyline.geometry.getCoordinates().length;
            for (let i=0; i<linarr; i++){
                    let zpt = i>0 ? point+'~' : '';
                    point=zpt+this.myPolyline.geometry.getCoordinates()[i][0]+','+this.myPolyline.geometry.getCoordinates()[i][1]+',pmwtm'+(i+1);
                    dataPoints.push(this.myPolyline.geometry.getCoordinates()[i]);
            }
            points='&pt='+point;
            urencod = this.myPolyline.geometry.getCoordinates();
            ssilka = 'http://static-maps.yandex.ru/1.x/?l=sat,skl&z=17&pl=c:faff00,'+urencod;
             
        }else{
            points='&pt='+this.myPoints.geometry.getCoordinates()[0][0]+','+this.myPoints.geometry.getCoordinates()[0][1]+',pmwtm1';
            dataPoints.push(this.myPoints.geometry.getCoordinates()[0]);
            ssilka = 'http://static-maps.yandex.ru/1.x/?l=sat,skl&z=17';
        }
 
        return {
            yad: ssilka+center+points+VRU,
            points: dataPoints,
            vru: VRUcoord, 
        };

    }

    onSave(){

        let data = this.createDataYad();
        this.visible = false;
        this.onSaveYad({data: data });


    }

    showModal(){
     
        this.modal.addClass('open');
        this.modal.find('.modal-inner').scrollTop(0);
        $('body').addClass('modal-open');
        window.initNoScroll();
        //this.setAddress('Россия, Москва, посёлок Толстопальцево, улица Ленина, 25');
    }
    hideModal(){
   
        this.modal.removeClass('open');
		if(!$('.modal__holder.open').length){
			$('body').removeClass('modal-open');
			window.initStartScroll();
		}
    }

    startPaint(){
        this.allowPaint = !this.allowPaint;
    }

    onAddVru(){

        this.placemarkVRY = new this.yamap.Placemark(this.map.getCenter(), {
            iconContent: "ВРУ",
            hintContent: "Перетащите на место ВРУ"
        }, {
            draggable: "true",
            preset: "islands#blueStretchyIcon",
            // Заставляем балун открываться даже если в нем нет содержимого.
            openEmptyBalloon: true
        });
        this.map.geoObjects.add(this.placemarkVRY);
        
        this.buttonVisible('save', true);
    }
    onReset(){
        this.myobj(1);
    }

    myobj(id){
        var mobj=[[1,this.myPoints],[2,this.myPolyline],[3,this.myPolygon]];
        var im;
        for (let i=0; i<mobj.length; i++){ 
            if(id==mobj[i][0]){
                this.map.geoObjects.add(mobj[i][1]);
                mobj[i][1].editor.startDrawing();
                im=1;
            }else{
                mobj[i][1].editor.stopDrawing();
                this.map.geoObjects.remove(mobj[i][1]);
            }
        }
        if(im){
            this.map.setZoom(18, {duration: 0});
            this.map.options.set('restrictMapArea',true);
        }else{
            this.map.options.set('restrictMapArea',false);
        }

        this.buttonVisible('vru', false);
        this.buttonVisible('reset', false);
        this.buttonVisible('save', false);
        this.buttonVisible('endDraw', false);

        
        if(typeof this.placemarkVRY != 'undefined'){
            this.map.geoObjects.remove(this.placemarkVRY);
        }
    }

    buttonVisible(button, state){
        this.buttons[button].options.set('visible', state);
    }

    setAddress(adres){
        this.yamap.geocode(adres, {
            results: 1 // Если нужен только один результат, экономим трафик пользователей
        }).then(bx.delegate(this.onFoundAddress, this));

    }
    onFoundAddress(res){
        // Выбираем первый результат геокодирования.
        var firstGeoObject = res.geoObjects.get(0),
        // Координаты геообъекта.
        coords = firstGeoObject.geometry.getCoordinates();
        // Область видимости геообъекта.
        //bounds = firstGeoObject.properties.get('boundedBy');
     
        this.map.setCenter(coords, 18, {
             checkZoomRange: true
        });
    }

}


class tooltipController   {
    static get $inject(){ return  ['$log', '$scope', '$element'];}
    constructor($log, $scope, $element){
        
        this.infoMessage = false;
        this.$element = $element;
        this.__errorMessage = false;
    }


    addTooltip(/*code, name*/){
        return ;
        /*
        bx.ajax.runComponentAction('cript:desktop', 'master-tootips-add', {
            mode:'class',
            data:{
                code:code, 
                name:name,
            }
        })
        */
    }

    get tooltip(){
        
        if(tootipsMaster===false){
            return false;
        }

        if(this.infoMessage){
            return true;
        }

       // console.info('check tootip '+this.fieldName);
        
        let tootip =tootipsMaster.find(obj => {
            if(!obj['OBMENFIELDS']){
                return false;
            }

            return obj['OBMENFIELDS'] === this.fieldName 
        });

        
        if(!tootip && this.fieldName && this.fieldInfo){
            this.addTooltip(this.fieldName, this.fieldInfo);
            return false;
        }
    
        if(!tootip){
            
            return false;
        }
        this.infoMessage =tootip.TOOLTIP;
        this.toolTipInfo.tooltipster('content', this.infoMessage );
        return tootip.TOOLTIP;
    }
    $postLink(){

        this.toolTipInfo = $(".tooltip.tooltip-info", this.$element).tooltipster({
            animation: "swing",
            theme: "tooltipster-shadow",
            contentAsHTML: true,
        })
        this.toolTipError =$(".tooltip.tooltip-error", this.$element).tooltipster({
            animation: "swing",
            theme: "tooltipster-shadow",
            contentAsHTML: true,
        });


        
    }

    get errorMessage(){
       return this.__errorMessage;
    }
    set errorMessage(value){
     
        this.__errorMessage = value;
        if(this.toolTipError && value){
            this.toolTipError.tooltipster('content', value );
        }
    }

}


class PreloaderController   {
    static get $inject(){ return  ['$log', '$scope', '$element'];}
    constructor($log, $scope, $element){
        
        
        this.$element = $element;
        
    }


    $postLink(){

   

        
    }

   
}


class SubmitButtonController extends FieldController{

}


export {

    PreloaderController,
    SubmitButtonController,
    tooltipController,
    modalMapController,
    InputController,
    inputCheckBoxController,
	inputCheckBoxPrivacyController,
	
    inputBankController,
    inputTextSwitchController,
    inputTextController,
    inputSwitchController,
   
    inputRegistrationController,
    inputEGRIPController,
    inputGenderController,
    inputSNILSController,
    inputFioController,
    inputOGRNController,
    inputYearMonthController
}
;



// WEBPACK FOOTER //
// ./src/components/elements/elements.controllers.module.js